module.exports = __webpack_public_path__ + "img/hero-pp.f594c575.jpg";